const i18nDict = {
  // Labels
  'Name': '姓名',
  'First Name': '名',
  'Last Name': '姓',
  'Country': '國家',
  'Phone': '電話',
  'Inquiry Type': '詢問類別',
  'Subject': '主旨',
  'Message': '內容',
  'Submit': '送出',

  // Select options
  'Please select': '請選擇',
  'Appointment for Showroom': '預約展間',
  'Purchase Inquiry': '購買需求',
  'Collaboration': '合作',
  'Feedback': '意見回饋',
  'Modification Inquiry': '修改疑問',
  'Other': '其他',

  // Messages
  'Thanks for getting in touch!': '感謝您的聯繫！',
  'We appreciate you contacting us. One of our colleagues will get back in touch with you soon!': '感謝您的聯繫！我們的同事會盡快回覆您！',
  'Have a great day!': '祝您有美好的一天！',
};

const locale = window.Shopify?.locale || document.documentElement.lang || 'en';




const observer = new MutationObserver((mutations) => {
  const $formApp = document.querySelector('.globo-form-app');

  if ($formApp) {
    const nodes = $formApp.querySelectorAll('div, p, label, select, [type="submit"]');

    const inputs = document.querySelectorAll('[placeholder]');

    inputs.forEach((input) => {
      input.setAttribute('placeholder', '');
    });

    if (locale === 'en') {
      return;
    }

    nodes.forEach((node) => {
      // 避免重複處理
      if (node.getAttribute('data-i18n-done') === 'true') return;

      // Label（優先處理 .label-content）
      if (node.matches('label')) {
        const labelContent = node.querySelector('.label-content') || node;
        const raw = (labelContent.textContent || '').trim();
        const translated = i18nDict[raw];
        if (translated) {
          labelContent.textContent = translated;
          labelContent.setAttribute('data-label', translated);
          node.setAttribute('data-label', translated);
          node.setAttribute('data-i18n-done', 'true');
          return;
        }
      }

      // Select > option
      if (node.matches('select')) {
        const options = node.querySelectorAll('option');
        options.forEach((opt) => {
          const raw = opt.textContent;
          const translated = i18nDict[raw];
          if (translated) {
            opt.textContent = translated;
            opt.setAttribute('value', translated);
          }
        });
        node.setAttribute('data-i18n-done', 'true');
        return;
      }

      // div/p 的一般文案
      if (node.matches('div, p, [type="submit"]')) {
        const raw = (node.textContent || '').trim();
        const translated = i18nDict[raw];
        if (translated) {
          node.textContent = translated;
          node.setAttribute('data-i18n-done', 'true');
          return;
        }
      }
    });
  }
})

observer.observe(document.body, {
  childList: true,
  subtree: true,
})